export default __webpack_public_path__ + "static/rolling_door_w.508c77127905150a815eecfc85eeb3ab.svg";